const transcriptMessage = entry => entry && !entry.compaction && entry.message

export const uncommittedStreamingTail = (stream, transcriptEntries) => {
  const value = typeof stream === 'string' ? stream : ''
  if (!value || !Array.isArray(transcriptEntries)) return value

  for (let index = transcriptEntries.length - 1; index >= 0; index -= 1) {
    const message = transcriptMessage(transcriptEntries[index])
    if (!message) continue

    // Only an immediately preceding plain assistant segment can overlap the
    // current stream. A user/tool/tool-call boundary establishes a new tail.
    if (message.role !== 'assistant' || message.tool_call_id ||
        (Array.isArray(message.tool_calls) && message.tool_calls.length > 0)) {
      return value
    }

    const committed = typeof message.content === 'string' ? message.content : ''
    if (!committed || committed === 'Got it.') return value
    if (value.startsWith(committed)) return value.slice(committed.length)
    if (committed.startsWith(value)) return ''
    return value
  }

  return value
}

export const appendStreamingDelta = (stream, delta) => {
  const current = typeof stream === 'string' ? stream : ''
  const incoming = typeof delta === 'string' ? delta : ''
  if (!incoming) return current
  if (!current) return incoming

  // Some provider bridges resend a cumulative snapshot or replay a sizeable
  // delta after reconnecting. Do not duplicate it in the live buffer. Keep
  // short repeated tokens untouched because they can be legitimate prose.
  if (incoming.length > current.length && incoming.startsWith(current)) {
    return incoming
  }
  if (incoming.length >= 32 && current.includes(incoming)) {
    return current
  }

  // A reconnect can replay the end of the previous event plus new text in a
  // single chunk. Preserve only the portion after a substantial overlap.
  const maxOverlap = Math.min(current.length, incoming.length)
  for (let overlap = maxOverlap; overlap >= 32; overlap -= 1) {
    if (current.endsWith(incoming.slice(0, overlap))) {
      return current + incoming.slice(overlap)
    }
  }
  return current + incoming
}
